
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import pc from './pc/articulos.vue';
    import movil from './pc/articulos.vue';

    @Component( {
        name: "Componente",
        props: {},
        components: { pc, movil }
    } )
    export default class Componente extends Vue
    {



    }
